import { combineReducers } from "redux";
import logger from "redux-logger";

import { persistStore, persistReducer } from "redux-persist";
import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";

import ingredientSlice from "./ingredient";

const reducers = combineReducers({
  ingredients: ingredientSlice,
});

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["ingredients"],
};

const persistedReducer = persistReducer(persistConfig, reducers);

const store = configureStore({
  reducer: persistedReducer,
  // middleware: getDefaultMiddleware({
  //   serializableCheck: false
  // })
  // middleware: [logger],
});

const persistor = persistStore(store);

export { store, persistor };
